export const EXPERTISE_AREAS = [
  "strategy",
  "marketing",
  "sales",
  "finance",
  "legal",
  "hr",
  "tech",
  "operations",
  "impact",
];

export function expertiseLabel(t, key) {
  const path = `expertise.${key}`;
  const label = t(path);
  return label === path ? key : label;
}
